import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { getTextConfigurationFields } from './constants'

export const TextConfiguration = () => {
  const [inputs, setInputs] = useState<Record<string, any>>(getTextConfigurationFields())
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAdminConfig('textConfig')
      .then((value) => {
        let newInputs = cloneDeep(inputs)
        Object.keys(inputs).map((key) => {
          newInputs[key].value = value[key] || ''
        })
        setInputs(newInputs)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: any) => {
    const nInputs = cloneDeep(inputs)
    nInputs[key].value = value
    setInputs(nInputs)
  }

  const onSubmit = async () => {
    const data: Record<string, any> = {}
    Object.keys(inputs).map((key) => {
      if (inputs[key].inputType === 'section') return
      data[key] = inputs[key].value
    })

    setLoading(true)
    await setAdminConfig('textConfig', data)
    setLoading(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />

      <div className="grid grid-cols-1 md:grid-cols-2 sm:gird-cols-2 gap-2">
        {Object.keys(inputs).map((key, index) => {
          const item = inputs[key]
          return (
            <div className={`input md:col-span-${item.span || 1} `} key={index}>
              <RenderInput key={index} input={item} Key={key} onChange={onChange} onBlur={onSubmit} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
